import { Component, OnInit, Pipe } from '@angular/core';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { colors } from 'src/utils/colors';

import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {DatePipe, Location} from '@angular/common';
import { Router,ActivatedRoute  } from "@angular/router";
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { browserRefresh } from 'src/app/app.component';
import { Subject } from 'rxjs';

import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';


@Pipe({
  name: "phone"
})
export class PhonePipe {
  transform(rawNum) {
   // rawNum = rawNum.charAt(0) != 0 ? "0" + rawNum : "" + rawNum;

    let newStr = "";
    let i = 0;

    if(rawNum.length==10){
    //const country = 1;
    const city = rawNum.slice(0, 3);
    const number = rawNum.slice(3);
    
    const finalnumber = number.slice(0, 3) + '-' + number.slice(3);

    return ( " (" + city + ") " + finalnumber).trim();
    } else{
      return "";
    }
  }
}


@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.css']
})
export class SearchPageComponent implements OnInit {

  currentUser:User;
  mytableappointment;
  branchselected;
  salesRep;
  clientSearchList:any=[];
  searchText;
loggedInUserBranch;
loggedInUserFullname;
loggedInUsername;
loggedInUserId;
branch;
error;
success;
inProgressModalList;

  constructor(private _authenticationService: AuthenticationService,
  private modalService: NgbModal,
  private router: Router, 
  private fb: FormBuilder,
  private actroute: ActivatedRoute,
  private _location: Location,
  private _appointment: AppointmentService,
  private _http: HttpClient,
  public datepipe: DatePipe) {

    
    this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
    if(this.currentUser){
      this.loggedInUsername=this.currentUser.userName;
    this.loggedInUserFullname=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
    this.loggedInUserBranch=this.currentUser.branch;
    this.loggedInUserId=this.currentUser.userName;
this.branch=this.loggedInUserBranch;
    } }

  ngOnInit(): void {
    //this.getSalesRepAppointment();
    this.getSalesRep(this.branch);
    this.getAllClients();

/******************************************************************************** */
  var salesrepappointment = document.getElementById("salesrepappointment");
  salesrepappointment.style.display = "block";

  var salesrepappointmentview=document.getElementById('salesrepappointmentview');
  salesrepappointmentview.style.backgroundColor='#FFFFFF';
  salesrepappointmentview.style.color=" #132a42";

  /******************************************************************************** */
  var clients= document.getElementById("clients");
  clients.style.display = "none";
  
  var clientsview=document.getElementById('clientsview');
  clientsview.style.backgroundColor='#132a42';
  clientsview.style.color="#FFFFFF";
  

  /******************************************************************************** */
  
  
  document.getElementById ("salesrepappointmentview").addEventListener ("click", SalesRepAppointmentFunction, false);
  document.getElementById ("clientsview").addEventListener ("click", ClientsFunction, false);

  }//End of NugOnInit



/********************************************************* */
getAllClients(){
  
       this._appointment.getAllClient().subscribe(
         (res) => {
           this.clientSearchList= res;
           console.log(this.clientSearchList);
  
      });
    }
  
  
   /********************************************************* */
   openClientDetails(client){

    this.router.navigate(['../client-details', { extra:client.pid, extra1: client.fullName,extra2:client.phoneNumber,extra3:client.email}], { relativeTo: this.actroute });
   }
  /********************************************************* */
  getSalesRepAppointment(salesrep){

    this._appointment.getSalesRepAppointmentByIDMainTable(salesrep,this.loggedInUserBranch).subscribe(
      (res) => {
        this.mytableappointment= res[0];
       // console.log(this.mytableappointment);
        if(this.mytableappointment[0]['ERROR']=='no appointment'){
          this.mytableappointment='no appointment'
        }
        
      },
      (err) => {
        this.error = err;
      }
    );
  
  }
  
  /********************************************************* */

  checkbarScan(date){
    if(date!=null && date!=""){
      var actualdatetime=new Date(date);
      var currentdatetime=new Date();
      var  daterange=new Date(actualdatetime.setMinutes(actualdatetime.getMinutes() + 60));
    //console.log(currentdatetime);
    if(currentdatetime<=daterange){
      return true;
    } else 
    {
      return false;
    } }else{
      return false;
    
    }
    }  

  /********************************************************* */
  
  
/********************************************************* */

openAppointment(list){
  console.log(list.pid);
  
  
  this.router.navigate(['../appointment-details', { extra: list.pid, extra1: list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.timeIn }], { relativeTo: this.actroute });
  
}


/********************************************************* */

editAppointment(list){
  console.log(list);
   if(list.fullName=='Lunch'){
     this.router.navigate(['../lunch-assignment',{extra:list.pid,extra1:list.timeIn,extra2:list.salesRep,extra3:list.branch,extra4:list.timeIn}],{relativeTo:this.actroute});
   }else{
  
  
    this.router.navigate(['../appointment-edit',{extra:list.pid,extra1:list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.timeIn}],{relativeTo:this.actroute});
   }
 }
/********************************************************* */
cancelAppointment(list){
  // console.log(list);
  list['status']="Cancelled";
   this._appointment.setAppointmentStatusbypid(list)
   .subscribe(//subscribe to Observable
     response => {console.log('Success!', response);
     this.success=response['SUCCESS'];
         
     document.getElementById("openSuccessStatusUpdateModalButton").click();
     
   },
     error => {console.error('Error!', error);
     this.error=error.error.text ;
   }       
   );
  }
  /********************************************************* */
  completeAppointment(list){
    // console.log(list);
    list['status']="Completed"
     this._appointment.setAppointmentStatusbypid(list)
     .subscribe(//subscribe to Observable
       response => {console.log('Success!', response);
       this.success=response['SUCCESS'];
           
       document.getElementById("openSuccessStatusUpdateModalButton").click();
       
     },
       error => {console.error('Error!', error);
       this.error=error.error.text ;
     }       
     );
   }
   /********************************************************* */
   
   clearbarScanAppointment(list){
     // console.log(list);
      this._appointment.clearbarScanbypid(list)
      .subscribe(//subscribe to Observable
        response => {console.log('Success!', response);
        this.success=response['SUCCESS'];
            
        document.getElementById("openSuccesssModalButton").click();
        this. getSalesRepAppointment;
      },
        error => {console.error('Error!', error);
        this.error=error.error.text ;
      }       
      );
    }
   /********************************************************* */
   /********************************************************* */

deleteAppointment(list){
  this._appointment.deleteAppointmentbypid(list)
  .subscribe(//subscribe to Observable
    response => {console.log('Success!', response);
    this.success=response['SUCCESS'];
        
    document.getElementById("openSuccessDeleteModalButton").click();
    
  },
    error => {console.error('Error!', error);
    this.error=error.error.text ;
  }       
  );
}
/********************************************************* */
inprogressAppointment(){
var count=((document.getElementById("personcount") as HTMLInputElement).value);
console.log(count);
this.inProgressModalList['status']="In Progress";
this.inProgressModalList['personCount']=count;
this.modalService.dismissAll();
this._appointment.setAppointmentStatusbypid(this.inProgressModalList)
 .subscribe(//subscribe to Observable
   response => {console.log('Success!', response);
   this.success=response['SUCCESS'];
       
   document.getElementById("openSuccessStatusUpdateModalButton").click();
   
 },
   error => {console.error('Error!', error);
   this.error=error.error.text ;
 }       
 );
}

/********************************************************* */
openInProgressModal(modal,apt){
  console.log(apt);
   this.inProgressModalList=apt;
       var finalmessage= "Please enter: "
     
   
     this.modalService.open(modal, {
       centered: true,
       backdrop: 'static'
     });
   
    
     
   }


   /***************************************************** */

getSalesRep(branch){
  // console.log(branch);
   if (branch != "None" || branch!="") {
     this._appointment.getSalesRepByBranch(branch).subscribe(
       (res) => {
         this.salesRep = res;
         console.log(this.salesRep);
         this.branchselected = true;
  
       }
       ,
       (err) => {
         this.error = err;
       }
     );
   }
   else {
     this.branchselected = true;
   }
 
 
 }
    /***************************************************** */
isAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.Administrator;
}

isSystemAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
}

isReceptionist() {
  return this.currentUser && this.currentUser.role === UserRole.Receptionist;
}

isSalesRep() {
  return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
}

isPowerUser() {
  return this.currentUser && this.currentUser.role === UserRole.PowerUser;
}

isSalesSupport() {
  return this.currentUser && this.currentUser.role === UserRole.SalesSupport;
}




backClicked() {
  this._location.back();
}
}



function SalesRepAppointmentFunction() {
  var cal = document.getElementById("salesrepappointment");
  cal.style.display = "block";

  var salesrepappointmentview=document.getElementById('salesrepappointmentview');
  salesrepappointmentview.style.backgroundColor='#FFFFFF';
  salesrepappointmentview.style.color="#132a42";

  /****************************************************** */
  var clientsview=document.getElementById('clientsview');
  clientsview.style.backgroundColor='#132a42';
  clientsview.style.color="#FFFFFF";
  

  var table = document.getElementById("clients");
  table.style.display = "none";
 
/****************************************************** */


  
}


function ClientsFunction() {
  var table = document.getElementById("clients");
  table.style.display = "block";

  /*********************************************************** */
  var cal = document.getElementById("salesrepappointment");
  cal.style.display = "none";

  var salesrepappointmentview=document.getElementById('salesrepappointmentview');
  salesrepappointmentview.style.backgroundColor='#132a42';
  salesrepappointmentview.style.color="#FFFFFF";
  
   
/****************************************************** */
  var clientsview=document.getElementById('clientsview');
  clientsview.style.backgroundColor='#FFFFFF';
  clientsview.style.color="#132a42";
  
 

}

